"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodeLocationResponse$ = exports.OutcodeLocationResponse$outboundSchema = exports.OutcodeLocationResponse$inboundSchema = void 0;
exports.outcodeLocationResponseToJSON = outcodeLocationResponseToJSON;
exports.outcodeLocationResponseFromJSON = outcodeLocationResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const outcodelocationwrapper_js_1 = require("./outcodelocationwrapper.js");
/** @internal */
exports.OutcodeLocationResponse$inboundSchema = z.object({
    data: outcodelocationwrapper_js_1.OutcodeLocationWrapper$inboundSchema,
});
/** @internal */
exports.OutcodeLocationResponse$outboundSchema = z.object({
    data: outcodelocationwrapper_js_1.OutcodeLocationWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodeLocationResponse$;
(function (OutcodeLocationResponse$) {
    /** @deprecated use `OutcodeLocationResponse$inboundSchema` instead. */
    OutcodeLocationResponse$.inboundSchema = exports.OutcodeLocationResponse$inboundSchema;
    /** @deprecated use `OutcodeLocationResponse$outboundSchema` instead. */
    OutcodeLocationResponse$.outboundSchema = exports.OutcodeLocationResponse$outboundSchema;
})(OutcodeLocationResponse$ || (exports.OutcodeLocationResponse$ = OutcodeLocationResponse$ = {}));
function outcodeLocationResponseToJSON(outcodeLocationResponse) {
    return JSON.stringify(exports.OutcodeLocationResponse$outboundSchema.parse(outcodeLocationResponse));
}
function outcodeLocationResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodeLocationResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodeLocationResponse' from JSON`);
}
//# sourceMappingURL=outcodelocationresponse.js.map